/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProductivityListUpdate
 */
export interface UserProductivityListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityListUpdate
     */
    userEmployeeId?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityListUpdate
     */
    userLastName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityListUpdate
     */
    userFirstName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityListUpdate
     */
    departmentLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserProductivityListUpdate
     */
    shiftLabel?: boolean | null;
}

/**
 * Check if a given object implements the UserProductivityListUpdate interface.
 */
export function instanceOfUserProductivityListUpdate(value: object): value is UserProductivityListUpdate {
    return true;
}

export function UserProductivityListUpdateFromJSON(json: any): UserProductivityListUpdate {
    return UserProductivityListUpdateFromJSONTyped(json, false);
}

export function UserProductivityListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProductivityListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userEmployeeId': json['userEmployeeId'] == null ? undefined : json['userEmployeeId'],
        'userLastName': json['userLastName'] == null ? undefined : json['userLastName'],
        'userFirstName': json['userFirstName'] == null ? undefined : json['userFirstName'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
        'shiftLabel': json['shiftLabel'] == null ? undefined : json['shiftLabel'],
    };
}

export function UserProductivityListUpdateToJSON(json: any): UserProductivityListUpdate {
    return UserProductivityListUpdateToJSONTyped(json, false);
}

export function UserProductivityListUpdateToJSONTyped(value?: UserProductivityListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEmployeeId': value['userEmployeeId'],
        'userLastName': value['userLastName'],
        'userFirstName': value['userFirstName'],
        'departmentLabel': value['departmentLabel'],
        'shiftLabel': value['shiftLabel'],
    };
}

